import { LitElement, html, css } from 'lit';

export class ArgosButton extends LitElement {
  static get styles() {
    return [
      css`
        :host {
          cursor: pointer;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          text-decoration: none;
          box-sizing: border-box;
          outline: 0;
          letter-spacing: 0.3px;
          border-radius: var(--argos-button-border-radius, 4px);
          font-family: var(--argos-button-font-family);
          font-size: var(--argos-button-font-size, 15px);
          padding: var(--argos-button-padding, 12px 24px);
          height: var(--argos-button-height, auto);
          background-color: var(--argos-button-bk-color, #fff);
          color: var(--argos-button-text-color, #ec0000);
          border: var(--argos-button-border, 2px solid #ec0000);
        }

        :host(:hover[data-waiting='false']:not([disabled])) {
          background-color: var(--argos-button-bk-color-hover, #ec0000);
          color: var(--argos-button-text-color-hover, #ffffff);
          border-color: var(
            --argos-button-border-color-hover,
            2px solid #ec0000
          );
        }

        :host([data-waiting='true']) {
          cursor: wait;
        }

        :host([disabled]) {
          background-color: var(--argos-button-bk-color-disabled, #dbdbdb);
          color: var(--argos-button-text-color-disabled, #979797);
          border-color: var(--argos-button-border-color-disabled, #dbdbdb);
          cursor: not-allowed;
        }

        .argos-button__loader {
          font-size: 10px;
          text-indent: -9999em;
          width: var(--argos-button-loader-size, 24px);
          height: var(--argos-button-loader-size, 24px);
          border-radius: 50%;
          background: var(--argos-button-text-color, #ec0000);
          background: linear-gradient(
            to right,
            var(--argos-button-text-color, #ec0000) 10%,
            rgba(255, 255, 255, 0) 62%
          );
          position: relative;
          animation: load 1.4s infinite linear;
          -webkit-transform: translateZ(0);
          -ms-transform: translateZ(0);
          transform: translateZ(0);
        }

        .argos-button__loader:before {
          width: 50%;
          height: 50%;
          background-color: var(--argos-button-text-color, #ec0000);
          border-radius: 100% 0 0 0;
          position: absolute;
          top: 0;
          left: 0;
          content: '';
        }

        .argos-button__loader:after {
          background-color: var(--argos-button-bk-color, #fff);
          width: 75%;
          height: 75%;
          border-radius: 50%;
          content: '';
          margin: auto;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
        }

        @-webkit-keyframes load {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
          }
        }

        @keyframes load {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
          }
          100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
          }
        }
      `,
    ];
  }

  render() {
    return html`
      ${!this.spinner
        ? html`
            <slot></slot>
            <span class="argos-button__text">${this.text}</span>
          `
        : html` <div class="argos-button__loader"></div> `}
    `;
  }

  static get properties() {
    return {
      text: { type: String },
      disabled: { type: Boolean },
      spinner: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.tabindex = 0;
    this.loader = false;
    this.setAttribute('data-waiting', false);
    this.addEventListener('click', this._click);
  }

  firstUpdated() {
    this.setAttribute('tabindex', this.tabindex);
  }

  updated(changedProperties) {
    changedProperties.forEach((oldValue, propName) => {
      if (propName === 'disabled') {
        if (!this.disabled) {
          this.removeAttribute('disabled');
          this.setAttribute('tabindex', this.tabindex);
        } else {
          this.setAttribute('tabindex', '-1');
          this.setAttribute('disabled', '');
        }
      } else if (propName === 'spinner') {
        this.setAttribute('data-waiting', this.spinner);
      }
    });
  }

  _click() {
    if (!this.disabled && !this.spinner) {
      this.dispatchEvent(new Event('onclick'));
    }
  }
}
